import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FootLogo from "../assets/footer_logo.png"; 

function Footer() {
    const { t } = useTranslation("footer"); 
    
    return (
        <footer>
            <div className="footer_wrap">
                <div>
                    <ul>
						<li>{t("company_name")}</li>
						<li>{t("business_number")}</li>
						<li>{t("ceo")}</li>
						<li>{t("address")}</li>
						<li>{t("customer_service")}</li>
                    </ul>
                    <ul>
                        <li>
                            <img src={FootLogo}  alt="로고" />
                        </li>
                        <li>
							<li>{t("copyright")}</li>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
